import React from 'react';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/js/plugins.pkgd.min.js';
import FroalaEditorComponent from 'react-froala-wysiwyg';
const Editor = _ref => {
  let {
    editorRef,
    config,
    model,
    onModelChange
  } = _ref;
  const options = {
    ...config,
    key: 'te1C2sD6C7A5F5H5I4jC1QUd1Xd1OZJ1ABVJRDRNGGUE1ITrE1D4A3C11B1B6A5B1F4E3==',
    imageUploadParam: 'file',
    imageUploadURL: '/api/froala/UploadFile',
    imageUploadParams: {
      id: 'my_editor'
    },
    imageUploadMethod: 'POST',
    imageMaxSize: 5 * 1024 * 1024,
    imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif'],
    imageManagerPageSize: 20,
    imageManagerScrollOffset: 10,
    imageManagerLoadURL: "/api/froala/loadimages",
    imageManagerLoadMethod: "GET",
    imageManagerDeleteURL: "/api/froala/deleteimage",
    imageManagerDeleteMethod: "DELETE",
    toolbarButtons: {
      'moreText': {
        'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
      },
      'moreParagraph': {
        'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
      },
      'moreRich': {
        'buttons': ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR']
      },
      'moreMisc': {
        'buttons': ['undo', 'redo', 'fullscreen', 'spellChecker', 'selectAll', 'html'],
        'align': 'right',
        'buttonsVisible': 2
      }
    },
    pluginsEnabled: ['align', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'imageTUI', 'imageManager', 'inlineStyle', 'lineBreaker', 'lineHeight', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote', 'save', 'table', 'url', 'wordPaste', 'fontAwesome'],
    attribution: false
  };
  return /*#__PURE__*/React.createElement(FroalaEditorComponent, {
    tag: "textarea",
    config: options,
    model: model,
    onModelChange: onModelChange
  });
};
export default Editor;